<template>
  <div class="video-player">
    <div :class="containerClasses">
      <VideoFiles v-if="fileUrl" :key="fileUrl" :file-url="fileUrl" :cover-url="coverUrl" />
      <VideoMux v-if="muxPlaybackId" :key="muxPlaybackId" :mux-playback-id="muxPlaybackId" :cover-url="coverUrl" />
      <VideoYoutube v-if="youtubeLink" :key="youtubeLink" :youtube-link="youtubeLink" />
      <VideoProcessing v-if="isProcessing" :key="muxVideoId" :mux-video-id="muxVideoId" @ready="onProcessingReady" />
    </div>
  </div>
</template>

<script>
import VideoFiles from './VideoFiles';
import VideoMux from './VideoMux';
import VideoProcessing from './VideoProcessing';
import VideoYoutube from './VideoYoutube';

export default {
  name: 'VideoPlayer',
  components: {
    VideoFiles,
    VideoMux,
    VideoProcessing,
    VideoYoutube,
  },
  props: {
    fileUrl: {
      type: String,
      default: '',
    },
    muxVideoId: {
      type: Number,
      default: null,
    },
    muxPlaybackId: {
      type: String,
      default: '',
    },
    youtubeLink: {
      type: String,
      default: '',
    },
    coverUrl: {
      type: String,
      default: '',
    },
    containerClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    isProcessing() {
      return this.muxVideoId && !this.muxPlaybackId;
    },
    containerClasses() {
      return ['video-player__inner', this.containerClass];
    },
  },
  methods: {
    onProcessingReady(muxPlaybackId) {
      this.$emit('ready', muxPlaybackId);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-player {
  width: 100%;
  height: 100%;
  display: flex;
  cursor: pointer;

  &__inner {
    width: 100%;
    height: 100%;
    display: flex;
  }
}
</style>
